<template>
    <div class="card" :style="{backgroundColor: color}">
        <img class="card-image" :src="'/img/' + icon" />
        <div class="card-content">
            <h4>{{value}}</h4>
            <span v-autosize="{ target: 13, min: 10 }">{{caption}}</span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Card',
  props: ['color', 'icon', 'value', 'caption']
}
</script>

<style scoped>
.card {
  float: left;
  width: 100%;
  border-radius: 8px;
  padding: 12px 14px;
  color: white;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.card:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
}

.card .card-image {
  float: left;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  margin-right: 10px;
}

.card .card-content {
  float: left;
  width: calc(100% - 48px);
  font-size: 12px;
  height: auto;
}

.card .card-content h4 {
  float: left;
  width: 100%;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  margin: 0 0 2px 0;
}

.card .card-content span {
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 0.85;
}

@media only screen and (max-width: 575px) {
  .card .card-content h4 {
    font-size: 16px;
  }

  .card .card-content {
    font-size: 11px;
    width: calc(100% - 44px);
  }

  .card .card-image {
    width: 34px;
    height: 34px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .card {
    padding: 10px 10px;
  }

  .card .card-content {
    font-size: 11px;
    width: calc(100% - 44px);
  }

  .card .card-content h4 {
    font-size: 16px;
  }

  .card .card-image {
    width: 34px;
    height: 34px;
    margin-right: 6px;
  }
}
</style>
